import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgIsolatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m20 7.32 11.1 8.45v16.91H8.9V15.77z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m20 8.83 9.93 7.623V31.63h-1V16.947L20 10.09l-8.93 6.857V31.6h-1V16.453z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m34.864 20.324-3.7 3.7a.44.44 0 0 0-.096.48.4.4 0 0 0 .095.142l.002.002 3.71 3.74-.71.704-3.708-3.738-.001-.001a1.44 1.44 0 0 1 0-2.037l3.7-3.7z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M33.92 20.47h-1.95v-1h2.95v2.97h-1z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M16 22.68a.3.3 0 0 1 .53.18 2.61 2.61 0 0 0 1.24 2s-1.51-5 2.18-7.44a.23.23 0 0 1 .35.26 2.64 2.64 0 0 0 .81 2.73c1.66 1.65 3.86 2.76 3.9 5.49a4.94 4.94 0 0 1-4.14 5A5 5 0 0 1 15 26a6.6 6.6 0 0 1 1-3.32m3.08 4.85a3.6 3.6 0 0 1-1.25.63.34.34 0 0 0-.1.59 3.64 3.64 0 1 0 4-6.07A3.64 3.64 0 0 1 20 27.81a2.42 2.42 0 0 0 .44-2.45 3.65 3.65 0 0 1-1.36 2.17"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgIsolatie);

export default ForwardRef;
